<template>
  <div>
    <section class="section">
      <div class="container">
       <div class="columns is-multiline">

        <div class="column is-12">
          <div class="content">
            <h1>Verlinken Sie Ihre Seite mit uns</h1>

            <p>Mit unserem Link Generator machen wir es Ihnen ganz einfach Ihre Webseite mit unserer Seite zu verlinken. Wählen Sie einfach eine Zieladresse aus, mit der Sie zu uns verlinken wollen. Kopieren Sie dann den HTML-Code von unten und fügen Sie ihn in Ihre Webseite ein. Unser Banner ist responsive und passt sich automatisch Ihre Webseite an. Die Minimalbreite beträgt 220px. Die Maximalbreite beträgt 520px. Beim Klick auf den Banner wird automatisch ein neues Fenster geöffnet.</p>

<div class="field">
  <label class="label" for="target">Mit welcher Seite wollen Sie verlinken?</label>
            <div class="control has-icons-left">
  <div class="select is-info is-fullwidth">
    <select v-model="target" name="target">
      <option disabled>Mit welcher Seite wollen Sie verlinken</option>
      <option>https://www.urlaubimwaldviertel.at/</option>
      <option v-for="(i, index) in content" :key="index">https://www.urlaubimwaldviertel.at/details/{{ i.seo.niceUrl }}</option>
    </select>
  </div>
  <span class="icon is-large is-left">
    <i class="fa fa-chain"></i>
  </span>
</div>
</div>

                        <div class="box"><h4>Vorschau:</h4>
        <a :href="target" target="_blank" style="margin-top:20px !important;margin-bottom:20px !important;">
          <span style="font-family: Arial, Helvetica, sans-serif !important;font-size:13px;color:black !important;">Finden Sie uns auf:</span><br>
          <div style="border: 1px solid #f1f1f1 !important;background-image:url(https://assets.urlaubimwaldviertel.at/images/4572-snippet-urlaub-im-waldviertel.png) !important;background-repeat:no-repeat !important;background-size:520px 52px !important;height:52px !important;width:100% !important;max-width:520px !important;min-width:220px !important;">&nbsp;</div>
          </a>

        </div>

<label class="label" for="code">Fügen Sie diesen Code in Ihre Webseite ein:</label>
<textarea class="textarea is-info" readonly name="code" @click="$event.target.select()">
&lt;a href="{{target}}" target="_blank" style="margin-top:20px !important;margin-bottom:20px !important;"&gt;&lt;span style="font-family: Arial, Helvetica, sans-serif !important;font-size:13px;color:black !important;"&gt;Finden Sie uns auf:&lt;/span&gt;&lt;br&gt;&lt;div style="border: 1px solid #f1f1f1 !important;background-image:url(https://assets.urlaubimwaldviertel.at/images/4572-snippet-urlaub-im-waldviertel.png) !important;background-repeat:no-repeat !important;background-size:520px 52px !important;height:52px !important;width:100% !important;max-width:520px !important;min-width:220px !important;"&gt;&amp;nbsp;&lt;/div&gt;&lt;/a&gt;
</textarea>

          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  data () {
    return {
      target: 'https://www.urlaubimwaldviertel.at/'
    }
  },
  metaInfo: {
    title: 'Verlinken Sie Ihre Seite',
    meta: [
      { vmid: 'description', name: 'description', content: 'Verlinken Sie Ihre Seite auf urlaubimwaldviertel.at in Ihre Webseite an' },
      { vmid: 'twitter:card', name: 'twitter:card', value: 'summary' },
      { vmid: 'og:title', property: 'og:title', content: 'Verlinken Sie Ihre Seite mit urlaubimwaldviertel.at' },
      { vmid: 'og:type', property: 'og:type', content: 'article' },
      { vmid: 'og:url', property: 'og:url', content: 'https://www.urlaubimwaldviertel.at/snippets/' },
      { vmid: 'og:image', property: 'og:image', content: 'https://assets.urlaubimwaldviertel.at/images/3892-2018-01-wwwurlaubimwaldviertelat.png' },
      { vmid: 'og:image:width', property: 'og:image:width', content: 1200 },
      { vmid: 'og:image:height', property: 'og:image:height', content: 630 },
      { vmid: 'og:description', property: 'og:description', content: 'Verlinken Sie Ihre Seite auf urlaubimwaldviertel.at in Ihre Webseite an' },
      { vmid: 'fb:app_id', property: 'fb:app_id', content: '1649771028438873' }
    ]
  },
  methods: {

  },
  computed: {
    content () {
      return this.$store.getters.content
    }
  }
}
</script>

<style>
</style>
